import {
  KEY_LISTS,
  KEY_COLORS,
  COLORS,
  KEY_COLORS_L2,
  COLORS_L2,
  KEY_COLORS_D1,
  KEY_COLORS_D2,
  COLORS_D1,
  COLORS_D2,
} from '../constants';

export const isKeyList = (targetList) =>
  KEY_LISTS.filter((list) => list === targetList)[0];

export const getListName = (targetList, lists) =>
  isKeyList(targetList) ||
  lists.filter((list) => list.docID == targetList)[0].name;

export const getListColor = (targetList, lists) =>
  KEY_COLORS[KEY_LISTS.findIndex((list) => list === targetList)] ||
  COLORS[lists.filter((list) => list.docID == targetList)[0].color];

export const getListColor_L2 = (targetList, lists) =>
  KEY_COLORS_L2[KEY_LISTS.findIndex((list) => list === targetList)] ||
  COLORS_L2[lists.filter((list) => list.docID == targetList)[0].color];

export const getListColor_D1 = (targetList, lists) =>
  KEY_COLORS_D1[KEY_LISTS.findIndex((list) => list === targetList)] ||
  COLORS_D1[lists.filter((list) => list.docID == targetList)[0].color];

  export const getListColor_D2 = (targetList, lists) =>
  KEY_COLORS_D2[KEY_LISTS.findIndex((list) => list === targetList)] ||
  COLORS_D2[lists.filter((list) => list.docID == targetList)[0].color];

export const checkListExist = (targetList, lists) =>
  lists.filter((list) => list.docID == targetList).length > 0;

export const getTaskCount = (targetList, lists) =>
  lists.filter((list) => list.docID == targetList)[0].taskCount;
